import React from 'react';
import { useSelector } from 'react-redux';
import {
  FiBookOpen,
  FiCalendar,
  FiChevronRight,
  FiLayers,
  FiZap,
  FiX,
} from 'react-icons/fi';
import DigitalLmsStudyViewer from '../components/DigitalLmsStudyViewer';
import LearningActions from '../components/LearningActions';
import CourseRegistrationPanel from '../components/CourseRegistrationPanel';
import DeviceCourseSelect from '../components/DeviceCourseSelect';
import useDigitalLmsData from '../hooks/useDigitalLmsData';
import TabletLearningDetail from './TabletLearningDetail';
import '../mobile/MobileDigitalLms.scss';
import './TabletDigitalLms.scss';

const TabletDigitalLms = ({ onClose }) => {
  const isStudyViewerOpen = useSelector((state) => state.reduxStore.isModalTestLms);
  const {
    closeLesson,
    courseGroups,
    isCourseLoading,
    isLessonLoading,
    lessons,
    newLessonCount,
    openLesson,
    selectClass,
    selectedClass,
    selectedLesson,
    userName,
  } = useDigitalLmsData();

  const rootClassName = `mobile-digital-lms tablet-digital-lms${
    isStudyViewerOpen ? ' is-study-viewer-open' : ''
  }`;

  if (selectedLesson) {
    return (
      <main className={rootClassName} aria-label="태블릿 디지털 LMS 학습 상세">
        <TabletLearningDetail lesson={selectedLesson} onBack={closeLesson} />
        <DigitalLmsStudyViewer device="tablet" />
      </main>
    );
  }

  return (
    <main className={rootClassName} aria-label="태블릿 디지털 LMS">
      <header className="mobile-lms-topbar tablet-lms-mobile-topbar">
        <div className="mobile-lms-brand" aria-label="K-EDU 디지털 LMS">
          <span>K</span>
          <div>
            <strong>Digital LMS</strong>
          </div>
        </div>
        <button type="button" onClick={onClose} aria-label="서비스 메뉴로 이동" title="닫기">
          <FiX aria-hidden="true" />
        </button>
      </header>

      <div className="mobile-lms-scroll tablet-lms-mobile-scroll">
        <div className="tablet-lms-mobile-dashboard">
          <section className="mobile-lms-hero tablet-lms-mobile-hero">
            <span className="mobile-lms-hero__eyebrow">
              <FiZap aria-hidden="true" /> 오늘의 학습
            </span>
            <h1>{userName}님, 반가워요!</h1>
            <p>배움의 흐름을 이어가 볼까요?</p>
            <div className="mobile-lms-hero__stats">
              <div>
                <FiBookOpen aria-hidden="true" />
                <span>등록 수업</span>
                <strong>{lessons.length}</strong>
              </div>
              <div>
                <FiZap aria-hidden="true" />
                <span>새 학습</span>
                <strong>{newLessonCount}</strong>
              </div>
            </div>
            <LearningActions classCode={selectedClass?.code} />
          </section>

          <section className="mobile-lms-course-picker tablet-lms-mobile-picker">
            <div className="mobile-lms-section-title">
              <div>
                <h2>수업 선택</h2>
              </div>
              <FiLayers aria-hidden="true" />
            </div>
            <DeviceCourseSelect
              courseGroups={courseGroups}
              isCourseLoading={isCourseLoading}
              selectedClass={selectedClass}
              selectClass={selectClass}
            />
          </section>

          <CourseRegistrationPanel className="tablet-course-registration" />

          <section className="mobile-lms-lessons tablet-lms-mobile-lessons">
            <div className="mobile-lms-section-title">
              <div>
                <h2>{selectedClass?.name || '학습 목록'}</h2>
              </div>
              <em>{lessons.length}</em>
            </div>

            {isLessonLoading && (
              <div className="mobile-lms-loading" aria-label="학습 목록 불러오는 중">
                <i /><i /><i />
              </div>
            )}

            {!isLessonLoading && lessons.length === 0 && (
              <div className="mobile-lms-empty">
                <FiBookOpen aria-hidden="true" />
                <strong>아직 등록된 학습이 없어요</strong>
                <span>새로운 수업이 등록되면 이곳에서 확인할 수 있어요.</span>
              </div>
            )}

            {!isLessonLoading && lessons.length > 0 && (
              <div className="tablet-lms-mobile-card-grid">
                {lessons.map((lesson) => {
                  const [year, month, day] = String(lesson.date || '').split('-');
                  return (
                    <button
                      type="button"
                      className="mobile-lesson-card"
                      key={lesson.sno || lesson.code}
                      onClick={() => openLesson(lesson)}
                    >
                      <span className="mobile-lesson-card__date">
                        <small>{month ? `${month}월` : year}</small>
                        <strong>{day || '-'}</strong>
                      </span>
                      <span className="mobile-lesson-card__content">
                        <span>
                          <small><FiCalendar aria-hidden="true" /> {lesson.date}</small>
                        </span>
                        <strong>{lesson.title}</strong>
                        <small>{lesson.writer || '담당 선생님'}</small>
                      </span>
                      <FiChevronRight className="mobile-lesson-card__arrow" aria-hidden="true" />
                    </button>
                  );
                })}
              </div>
            )}
          </section>
        </div>
      </div>

      <DigitalLmsStudyViewer device="tablet" />
    </main>
  );
};

export default TabletDigitalLms;
